import { Fragment } from "react";
import { Grid, Typography } from "@mui/material";

import { Paper } from "../../../components";
import { colors } from "../../css components/Style";
import ReadyMadeCohorts from "../../readymade cohorts/ReadyMadeCohorts";

export default function QuickSegments() {
  return (
    <Fragment>
      <Grid style={{ margin: "20px 0" }} textAlign={"center"}>
        <Typography
          style={{
            background: colors.publicisBlue,
            padding: "10px",
            borderRadius: "10px",
            color: "#fff",
          }}
          variant="h4"
        >
          Connected ID - Quick Segments
        </Typography>
      </Grid>

      <Paper style={{ padding: "10px 30px" }}>
        <ReadyMadeCohorts />
      </Paper>
    </Fragment>
  );
}
